// @ts-nocheck

/**
 * * `coloring` - Coloring
 * `math` - Math
 * `reading` - Reading
 * `activity` - Activity
 * `special` - Special
 */
export type Category256Enum =
  typeof Category256Enum[keyof typeof Category256Enum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Category256Enum = {
  coloring: "coloring",
  math: "math",
  reading: "reading",
  activity: "activity",
  special: "special",
} as const;
